// extracted by mini-css-extract-plugin
export default {"imgStyle":"home_imgStyle__qJ3vl"};